
import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'

import './plugins/vuex'
import './plugins/bootstrap-vue'
import './plugins/papaparse'
import './plugins/browser-detect'

import App from './App.vue'
import router from './router'
import store from './store/store'

Vue.config.productionTip = false

new Vue({
	router,
	store,
  render: h => h(App)
})
.$mount('#app')